module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../hyperdb-utils/~/babel-runtime/core-js/array/from.js
// module id = 751
// module chunks = 0